import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NxaFAQMessage = () => {
  const [openQuestions, setOpenQuestions] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  // ✅ Corrected useEffect (moved outside the function)
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // ✅ Fixed toggleQuestion function
  const toggleQuestion = (index) => {
    setOpenQuestions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="index-sec-1 pricing-page-faq">
      <div className="container">
        <h2
          className="font--31 color-293F  fw--400"
          style={{ justifyContent: "center", textAlign: "center" }}
        >
          NxaTel Pricing FAQs
        </h2>
        <div className="row">
          {/* Question 1 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">1</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(1)}
                    aria-expanded={openQuestions[1]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What messaging
                    {isMobile ? " " : <br />}
                    platforms are supported?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[1] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    We support WhatsApp, SMS, Web Chat, and Social Messengers
                    like Facebook Messenger and Instagram DM.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 2 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">2</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(2)}
                    aria-expanded={openQuestions[2]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I assign chats to {isMobile ? " " : <br />}
                    specific team members?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[2] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes, conversations can be assigned based on skillset,
                    availability, or predefined rules.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 3 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">3</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(3)}
                    aria-expanded={openQuestions[3]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Does the platform allow
                    {isMobile ? " " : <br />}
                    scheduling follow-ups?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[3] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Absolutely! You can take notes, schedule follow-ups, and set
                    callback reminders within the messaging portal.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {/* Question 4 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">4</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(4)}
                    aria-expanded={openQuestions[4]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How does the team inbox {isMobile ? " " : <br />} work?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[4] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    The team inbox centralises all conversations, allowing
                    multiple team members to collaborate and respond
                    efficiently.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 5 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="number-of-boxIndex">5</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(5)}
                    aria-expanded={openQuestions[5]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I track interactions?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[5] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes, the platform provides a comprehensive customer
                    interaction history, ensuring continuity in communication.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 6 */}
          <div className="col-md-4">
            <div
              className="pricing-sec-box d-flex"
              style={{ background: "#ffff" }}
            >
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-boxIndex">
                    <h6 className="text--orange">6</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(6)}
                    aria-expanded={openQuestions[6]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Is messaging secure?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[6] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes, NxaTel ensures end-to-end encryption and secure data
                    storage to protect customer interactions and business
                    communications.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NxaFAQMessage;
